export default "__VITE_ASSET__DHAZ$cPx__"